const all = {
  all: "ทั้งหมด",
  point_channel: "ช่องทางสะสมคะแนน",
  member_tier: "ระดับสมาชิก",
  total_spend: "คะแนน คงเหลือ",
  more_spending: "สะสมยอดเพิ่ม",
  marketplace_channel: "ช่องทางการเชื่อมต่อ",
  placeholder_marketplace_select: "กรุณาเลือกช่องทางการสั่งซื้อ",
  placeholder_marketplace_select_2: "กรุณาเลือกร้านค้า",
  status: "Status",
  connect_status: "เชื่อมต่อสมบูรณ์",
  connect_status_error: "",
  btn_connect_market: "เพิ่มช่องทางเชื่อมต่อ",
  btn_connect_success_market: "เชื่อมต่อสมบูรณ์",
  btn_disconnect_market: "ลบการเชื่อมต่อ",
  btn_connect: "เชื่อมต่อ",
  redeem_quantity: "จำนวนสินค้าที่แลก",
  point_used: "จำนวนผลคะแนนที่ใช้",
  expired: "Expired",
  expired_date: "Expiration date",
  member_expired_date: "วันหมดอายุสมาชิก",
  point_total: "คะแนนสะสมของคุณ",
  currency_unit: "คะแนน",
  note: "หมายเหตุ ***",
  note_market: "สำหรับการเชื่อมต่อช่องทางต่างๆ",
  note_market_1:
    "การเชื่อมต่อช่องทางครั้งแรก สามารถเชื่อมต่อได้หลังจากการกดยืนยันรับสินค้า 1 ชั่วโมง",
  note_market_2:
    "สำหรับครั้งถัดไป ข้อมูลคำสั่งซื้อจะเข้าอัตโนมัติ หลังจากยืนยันรับสินค้า ภายใน 1 ชั่วโมง",
  history: "ประวัติการใช้",
  see_detail: "Details",
  description: "รายละเอียด",
  redeem_date: "แลกได้ถึง",
  use: "ใช้",
  profile_general: "MY INFORMATION",
  profile_address: "ข้อมูลที่อยู่",
  profile_additional: "ข้อมูลเพิ่มเติม",
  policy: "Privacy Policy",
  pdpa: "จัดการข้อมูลส่วนตัว",
  term: "ข้อกำหนดและเงื่อนไข",
  billing: "ที่อยู่ใบกำกับภาษี",
  shipping: "ที่อยู่จัดส่ง",
  contact: "บุคคลติดต่อ",
  add_billing: "เพิ่มที่อยู่ใบกำกับภาษี",
  add_shipping: "เพิ่มที่อยู่จัดส่ง",
  add_contact: "เพิ่มบุคคลติดต่อ",
  info_billing: "ข้อมูลที่อยู่ใบกำกับภาษี",
  info_shipping: "ข้อมูลที่อยู่จัดส่ง",
  info_contact: "ข้อมูลบุคคลติดต่อ",
  use_as_profile: "ใช้ที่อยู่ส่วนตัว",
  add: "เพิ่ม",
  ext: "ต่อ",
  default: "ค่าเริ่มต้น",
  save: "Save Changes",
  confirm: "[Test] Confirm",
  branch_select_coupon: "กรุณาเลือกสาขา",
  confirm_used: "ยืนยันการใช้งาน",
  already_used: "ใช้งานเรียบร้อย",
  cancel: "CANCEL",
  close_window: "ปิดหน้าต่างนี้",
  mission_detail: "รายละเอียดมิชชั่น",
  mission_reward: "ชุดของขวัญ",
  get_reward: "เช้าร่วม",
  spending: "สะสมยอดซื้อสินค้า",
  stamp_collect: "ต้องมีอย่างน้อย",
  stamp: "สิทธิ์",
  finish: "เสร็จสิ้น",
  process: "กำลังดำเนินการ",
  privilege_receive_success: " ",
  privilege_code: "โค้ดสิทธิพิเศษ",
  privilege_code_error: "โค้ดสิทธิพิเศษไม่ถูกต้อง",
  privilege: "สิทธิประโยชน์",
  privilege_header:"คูปองของคุณ",
  placeholder: "กรุณากรอก",
  use_coupon: "REDEEM IN STORE",
  coupon_code: "VOUCHER CODE",
  coupon_note:
    "<p>emaiหากหาหาsigngisterreteceิmaพem&nbsp;</p>\r\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n<br />",
  point_receive_total: "จำนวนคะแนนที่ได้รับ/ใช้งาน",
  list: "รายการ",
  profile: "ข้อมูลส่วนตัว",
  logout: "LOG OUT",
  member_tier_expired: "ระบบจะปรับระดับสมาชิกใน",
  to_upgrade: "เพื่ออัปเกรด",
  maintain: "เพื่อรักษาระดับ",
  next_tier: "ลำดับต่อไป",
  keep_current: "เพื่อรักษาระดับ",
  qr_count_time: "QR Code will expire in",
  total_spend_unit: "คะแนนสะสม (คะแนน)",
  count_purchase_times: "ซื้อสินค้า (ครั้ง)",
  count_purchase_unit: "ซื้อสินค้า (บาท)",
  collect_point: "คะแนนสะสม",
  total_collect_point: "คะแนนสะสม",
  back: "Back",
  need_point: "ต้องการคะแนนเพิ่ม",
  complate_profile: "ความครบถ้วนของข้อมูล",
  edit_profile: "แก้ไขข้อมูลส่วนตัว",
  edit: "EDIT",
  firstname: "ชื่อ",
  lastname: "นามสกุล",
  email: "อีเมล",
  telephone: "[Test] Phone Number",
  birthday: "วันเกิด",
  point_expired: "คะแนนที่จะหมดอายุ",
  success: "สำเร็จ",
  confirm_header_text: "คุณต้องการทำรายการนี้ หรือไม่ ?",
  amount: "จำนวน",
  default_input_validate: "is required",
  redeem_text: "ของขวัญ",
  search: "ค้นหา",
  clear_filter: "ล้างตัวกรอง",
  remain: "คงเหลือ",
  piece: "ชิ้น",
  no_detail: "ไม่มีรายละเอียด",
  no_data: "ไม่พบข้อมูล",
  number_times: "จำนวนสิทธิ์",
  loading: "กรุณารอสักครู่",
  create_date: "วันที่สร้าง",
  way_to_earn: "เพิ่มช่องทางการสะสมคะแนน",
  free_point: "รับคะแนนสะสมฟรี",
  purchase_channel: "ช่องทางการสั่งซื้อ",
  market_name: "ชื่อร้านค้า",
  order_no: "หมายเลขสั่งซื้อ (Order No.)",
  track_id: "หมายเลขจัดส่ง (Tracking ID.)",
  info_manage: "จัดการข้อมูลส่วนตัว",
  additional_note: "ระบุเหตุผลเพิ่มเติม",
  request_information: "ขอเข้าถึงข้อมูล",
  request_transfer_information: "ขอให้โอนข้อมูล",
  request_deny_information: "ขอให้เพิกถอนความยินยอม",
  request_edit_information: "ขอแก้ไขข้อมูล",
  request_suspend_information: "ขอให้ระงับและคัดค้านการใช้ข้อมูล",
  request_delete_information: "ขอให้ลบข้อมูล",
  login_title: "Create Profile / Sign In",
  register_title: "CREATE PROFILE / SIGN IN",
  telephone_title: "[Test] Telehpone Title",
  telephone_subtitle: "",
  redeem_exceed_quota_per_customer_title: "คุณได้แลกสิทธิครบตามที่กำหนดแล้ว",
  redeem_exceed_quota_title: "ของรางวัลหมด",
  redeem_button: "แลกสินค้า",
  redeem_remark:
    "ท่านสามารถรับชุดของขวัญได้ที่เคาน์เตอร์ Clarins สาขาที่ท่านเลือกเท่านั้น ภายในวันที่ XX กุมภาพันธ์ - XX มีนาคม",
  mission_title: "Membership Activity TH",
  upcomming_text: "Upcoming Reward",
  upload_receipt_loading:
    "ระบบกำลังทำการตรวจสอบ ขอขอบคุณลูกค้าที่ใช้บริการ ท่านสามารถกลับมาตรวจสอบสถานะได้ภายหลัง",
  header_shipping_address_form: "",
  footer_shipping_address_form: "",
  header_billing_address_form: "",
  footer_billing_address_form: "",
  header_contact_address_form: "",
  footer_contact_address_form: "",
  header_register_form: "",
  footer_register_form: "",
  delete: "ลบ",
  shipping_methods: "รูปแบบการจัดส่ง",
  social_media: "โซเซียลมีเดีย",
  your_telephone: "เบอร์โทรศัพท์ของคุณ",
  main_telephone: "เบอร์โทรศัพท์ (เบอร์หลัก)",
  optional_telephone: "เบอร์โทรศัพท์สำรอง",
  your_spending: "ยอดใช้จ่ายของคุณ",
  close: "ปิด",
  default_select_validate: "กรุณาเลือกข้อมูล",
  filter: "กรองข้อมูล",
  choose: "กำลังเลือก",
  confirm_logout: "Do you want to logout ?",
  next_page: "CONTINUE",
  send_otp_message: "Please fill in the erification code sent to",
  fill_otp: "",
  change_telephone: "Change Phone Number",
  skip: "ข้าม",
  earn_channel: "ช่องทางการสะสมคะแนน",
  privilege_for: "สิทธิประโยชน์สำหรับ",
  setting: "ตั้งค่า",
  change_language: "เปลี่ยนภาษา",
  language: "ภาษา",
  date: "เวลาปัจจุบัน",
  wait_otp: "You will receive the OTP code in",
  send_otp: "Resend",
  register: "Register",
  consent_policy_message:
    "By signing up for this membership, I declare that I have read and agreed to COS Thailand’s {{policy}} and {{term}}&nbsp;",
  consent_term_message:
    "I consent to COS Thailand sharing my personal data with its related group of companies, for the purpose of direct marketing by them for other offerings in Thailand, according to {{policy}} and {{term}}&nbsp;",
  your_receipt: "ใบเสร็จของคุณ",
  history_use: "ประวัติ",
  per_day: "ต่อวัน",
  limit_user_receipt: "วันนี้คุณได้ส่งตรวจสอบครบแล้ว",
  no_receipt_upload: "ยังไม่มีใบเสร็จ กรุณาส่งใบเสร็จ",
  send_receipt: "ส่งใบเสร็จ",
  confirm_send_receipt: "ยืนยันการส่งใบเสร็จ ?",
  confirm_message_send_receipt:
    "ยืนยันการส่งใบเสร็จ กรุณาตรวจสอบความถูกต้องก่อนส่งใบเสร็จ ระบบจะตรวจสอบและยืนยันสิทธิภายใน 24 ชม.",
  receipt_campaign_date: "ขออภัย Campaign นี้สามารถใช้งานได้วันที่",
  receipt_campaign_expired: "ขออภัย Campaign นี้หมดอายุแล้ว",
  receipt_campaign_not_found: "ขออภัยไม่พบ Campaign ที่ร่วมรายการ",
  go_to_history: "ไปที่หน้าประวัติ",
  receipt_upload_success: "อัพโหลดใบเสร็จสำเร็จ",
  receipt_unit: "ใบ",
  confirm_delete_receipt: "ยืนยันการลบใบเสร็จ ?",
  confirm_message_delete_receipt:
    "ยืนยันการลบใบเสร็จ กรุณาตรวจสอบความถูกต้องก่อนลบใบเสร็จ",
  validate_input_min_length: "Invalid Phone Number",
  validate_input_max_length: "กรุณากรอกไม่เกิน",
  validate_input_number: "กรุณากรอกตัวเลขเท่านั้น",
  validate_english_only: "กรอกเฉพาะตัวอักษรเท่านั้น",
  validate_english_num_only: "กรอกเฉพาะตัวอักษรภาษาอังกฤษและตัวเลขเท่านั้น",
  validate_id_card: "กรุณากรอกรูปแบบบัตรประชาชนให้ถูกต้อง",
  validate_email: "กรุณากรอกอีเมล (เช่น email@example.com)",
  character: "",
  news: "ข่าวสาร",
  spending_history: "ประวัติคะแนนสะสม",
  branch_spending: "คะแนนสะสมสาขาของคุณ",
  current_total_spend: "คะแนนสะสมปัจจุบัน",
  all_accumulate: "คะแนนสะสมทั้งหมด",
  send_check: "ส่งตรวจสอบ",
  invoice_no: "เลขที่ใบเสร็จ",
  collect_point_all: "คะแนนสะสมทั้งหมด",
  telephone_change_subtitle: "",
  receipt_cancel_invoice: "ยกเลิกรายการนี้",
  receipt_max_error_message_1:
    "เนื่องจากมีการส่งใบเสร็จที่ไม่สามารถตรวจสอบได้เกิน",
  receipt_max_error_message_2:
    "ครั้งต่อวัน\\n กรุณาลองใหม่ในวันพรุ่งนี้ หรือ ติดต่อเจ้าหน้าที่",
  receipt_max_upload_message: "วันนี้คุณได้ส่งตรวจสอบครบแล้ว'",
  error_message: "เกิดข้อผิดพลาด !",
  upload_image_text: "เพิ่มรูปภาพ",
  day: "DAY",
  month: "MONTH",
  year: "YEAR",
  year_ad: "ค.ศ.",
  year_be: "พ.ศ.",
  upgrade_unit: "บาท",
  allow_login_error_message: "Now Allow New User for Registering.",
  email_login_message: "[Test]เข้าสู่ระบบด้วยอีเมล",
  telephone_login_message: "เข้าสู่ระบบด้วยเบอร์โทรศัพท์",
  send_email_otp_message: "Enter the code we sent via email to ",
  change_email: "เปลี่ยนอีเมล",
  change_email_title: "เปลี่ยนอีเมล",
  email_change_subtitle: "",
  email_subtitle: "",
  email_title: "CREATE PROFILE / SIGN IN",
  fill_otp_email_login: "กรุณากรอกรหัส Otp ที่ได้รับลงไปในฟิลด์อีเมล",
  wait_otp_email_login: "You will recieve the OTP code in ",
  send_otp_email_login: "Resend Otp Email",
  consent_policy_message_email_login_pdpa_email:
    '<span data-metadata="&lt;!--(figmeta)eyJmaWxlS2V5Ijoib2F1WDdFc1pleFlPRW1WRk1WbTM2ZCIsInBhc3RlSUQiOjE5NTA4MzQ5NzAsImRhdGFUeXBlIjoic2NlbmUifQo=(/figmeta)--&gt;"></span><span style="white-space-collapse: preserve;">I consent to&nbsp;PT&nbsp;GTiga&nbsp;Kap Indonesia&nbsp;sharing my personal data&nbsp;(according to&nbsp;PT&nbsp;GTiga&nbsp;Kap Indonesia’s&nbsp;</span><span style="white-space-collapse: preserve;">{{policy}}</span><span style="white-space-collapse: preserve;">)&nbsp;with its related group of companies,&nbsp;which includes&nbsp;the&nbsp;necessary&nbsp;transfer of my personal data out of Indonesia,&nbsp;for the purpose of direct marketing by them for other offerings in Indonesia&nbsp;or membership program&nbsp;(if any).&nbsp;</span>',
  consent_term_message_email_login_policy_email:
    '<p><span style="white-space-collapse: preserve;">I&nbsp;consent to the processing of&nbsp;my personal data&nbsp;(according to, and for the purposes set out in,&nbsp;PT&nbsp;GTiga&nbsp;Kap Indonesia’s&nbsp;{{policy}}),&nbsp;which includes&nbsp;the&nbsp;necessary&nbsp;transfer of my personal data out of Indonesia&nbsp;(1)&nbsp;to a country where&nbsp;PT&nbsp;GTiga&nbsp;Kap Indonesia&nbsp;stores&nbsp;my personal data,&nbsp;and (2) to&nbsp;Golden Goose S.p.A.&nbsp;whose privacy policy can be found at&nbsp;<a href="https://www.goldengoose.com/ww/en/privacy.html" target="_blank" rel="noopener noreferrer">https://www.goldengoose.com/ww/en/privacy.html.&nbsp;</a></span></p>',
  policy_email: "Privacy policy",
  term_email: "Term Email",
  win_reward: "ยินดีด้วยคุณได้รับรางวัล",
  received_prize: "ได้รับของรางวัล",
  received_prize_description:
    "ดวงของคุณยังดีอยู่ กดดูของรางวัลเพื่อไปต่อได้เลย",
  not_received_prize: "คุณไม่ได้รับรางวัล",
  view_random_reward_prize: "ดูของรางวัล",
  view_mission_prize: "กดเพื่อดูของรางวัล",
  open_box: "เปิดกล่องรางวัลของคุณ",
  open_all_box: "เปิดทั้งหมด",
  send_more_code: "ส่งรหัสเพิ่ม",
  random_reward_title: "สแกนลุ้นรับกับ",
  mission_random_reward_title: "สแกนลุ้นรับกับ Mission Dcrm",
  random_reward_description:
    'ถ้าเตรียมดวงพร้อมแล้ว "เปิดกล่องรางวัล" เพื่อลุ้นโชคกันเลย',
  mission_random_reward_description:
    'ถ้าเตรียมดวงพร้อมแล้ว "เปิดกล่องรางวัล" เพื่อลุ้นโชคกันเลย',
  back_mission_prize: "กลับไปหน้าหลัก Mission 1",
  back_random_reward_prize: "กลับไปหน้าหลัก",
  receive_reward: "ได้รับ",
  not_receive_reward: "ไม่ได้รับ",
  close_edit: "CLOSE EDIT",
  minimal_transaction_tab_title: "TRANSACTION HISTORY",
  minimal_profile_tab_title: "MY PROFILE",
  transaction_empty: "You haven't purchased any products yet.",
  transaction_description:
    "We're currently unable to display some detailed order history due to recent updates. Thank you for patience and understanding.",
  transaction_title: "IN-STORE PURCHASE",
  text_send_otp: "Send OTP",
  continue: "Continue",
  member_qr_title: " MEMBERSHIP BARCODE",
  otp_input_title: "Email OTP - 6 Digits",
  purchase_note: "Color/Size",
  purchase_id: "Purchase ID",
  purchase_date: "DATE",
  purchase_store: "STORE",
  member_id: "MEMBER ID",
  transaction_header: "TRANSACTION HISTORY",
  passport_description: "[New User Login] Passport Description",
  passport_title: "[New User Login] Passport Title",
  passport_verify_title: "[Existed User] Passport Verify Title",
  passport_verify_description: "[Existed User] Passport Verify Description",
  verification_type_title: "Verifing Your Identity",
  verification_type_description:
    "เลือกวิธียืนยันตัวตนโดยการระบุ เลขบัตรประชาชน หรือ เลขพาสปอร์ต",
  card_title: "[New User Login] ID Card Title",
  card_verify_title: "[Existed User] Verification Type",
  card_description: "[New User Login] Select Verification Type",
  card_verify_description: "[Existed User] Card Verify Description",
  profile_coupon: "My Coupons",
  coupon_detail_title: "Coupon Details",
  coupon_note_title: "REDEEM VOUCHER",
  voucher_active: "VOUCHER ACTIVE",
  save_change: "Save Changes",
  cancel_change: "Cancel Changes",
  register_success_message: "ระบบได้รับข้อขมูลเรียบร้อย",
  coupon_is_already_used: "คูปองถูกใช้งานเรียบร้อย",
  validate_phone_format: "รูปแบบเบอร์โทรไม่ถูก",
  telephone_example: "08XXXXXX",
  example: "example",
  email_example: "example@mail.com",
  welcome: "HELLO'",
  currency_sign: "SGD",
  email_duplicate: "Cannot use this email address",
  birthday_at_least:
    "You have to be at least {{year}} years old to become a member",
  member_benefit: " ",
  consent_term_intro: "teest term intro ...44",
  consent_policy_intro: " teest policy intro ...44",
  consent_email_policy_intro:
    "PT GTiga Kap Indonesia (authorised retailer of the Golden Goose brand in Indonesia) is Golden Goose S.p.A.’s appointed data processor following a data processor appointment. \\n I understand and agree that in order to receive any services from Golden Goose S.p.A. or PT GTiga Kap Indonesia: ",
  consent_email_term_intro: "I am interested in other offerings: "
};

const standardV2 = {
  home: "หน้าหลัก",
  right_unit: "สิทธิ์",
  news_and_promotion: "ข่าวสารและโปรโมชั่น",
  credit_balance: "เครดิตคงเหลือ",
  package_balance: "แพ็กเกจคงเหลือ",
  voucher_balance: "วอเชอร์คงเหลือ",
  spa_wallet: "สปาวอลเล็ต",
  spa_wallet_expiring_soon: "รายการใกล้หมดอายุ",
  spa_wallet_vouchers: "เวาเชอร์",
  spa_wallet_packages: "แพ็กเกจ",
  spa_wallet_remaining_quantity: "จำนวนคงเหลือ",
  spa_wallet_purchase_date: "วันที่ซื้อ",
  spa_wallet_expiration_date: "วันหมดอายุ",
  spa_wallet_used: "USED",
  spa_wallet_tab_available: "พร้อมใช้",
  spa_wallet_tab_unavailable: "ไม่สามารถใช้ได้",
  spa_wallet_not_use_service_yet: "ยังไม่มีการใช้บริการ",
  privilege_channel_online: "ออนไลน์",
  privilege_channel_store: "หน้าร้าน",
  privilege_expiring_soon: "ใกล้หมดอายุ",
  privilege_expiration_label: "หมดอายุ",
  mission_progress_summary: "เสร็จสิ้น / ทั้งหมด",
  mission_complete_to_receive_reward: "สำเร็จภารกิจเพื่อรับรางวัล",
  mission_action: "ทำภารกิจ",
  credit_top_up_history: "ประวัติการเติมเครดิต",
  credit_top_up: "เติมเครดิต",
  credit_usage: "ใช้เครดิต",
  credit_unit: "เครดิต",
  try_again_later: "เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง",
  coupon_countdown_warning:
    "โค้ดนี้มีอายุการใช้งาน {{minute}} นาที หลังกดยืนยันรับสิทธิ์\nหากไม่ใช้สิทธิ์ภายในเวลาที่กำหนดจะถือว่าสละสิทธิ์\nทางบริษัทฯ จะไม่ชดเชยรหัสคืนในทุกกรณี",
  qr_code: "QR Code",
  barcode: "Barcode",
  consent_receive_news:
    "ฉันต้องการรับสิทธิพิเศษและโปรโมชั่น รวมถึงข่าวสารจาก {{brand}} ตามที่ระบุไว้ใน",

  consent_personal_data:
    "ฉันขอให้ความยินยอมโดยชัดแจ้งในการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลของฉัน ดังมีรายละเอียดปรากฏตาม",
  month_january: "มกราคม",
  month_february: "กุมภาพันธ์",
  month_march: "มีนาคม",
  month_april: "เมษายน",
  month_may: "พฤษภาคม",
  month_june: "มิถุนายน",
  month_july: "กรกฎาคม",
  month_august: "สิงหาคม",
  month_september: "กันยายน",
  month_october: "ตุลาคม",
  month_november: "พฤศจิกายน",
  month_december: "ธันวาคม",
  reward_redeem_success: "แลกรับของรางวัลสำเร็จ",
  reward_redeem_now: "แลกได้เลย",
  send_now: "ส่งเลย",
  next: "ต่อไป",
  friend_invite_link: "ลิ้งค์ชวนเพื่อน",
  link: "L I N K",
  copy_link: "Copy Link.",
  invited_friends: "เพื่อนที่ชวนแล้ว",
  already_member: "ขออภัย คุณเป็นสมาชิกแล้ว",
  receive_gift: "รับของขวัญ",
  package: "แพ็กเกจ",
  package_name: "ชื่อแพ็กเกจ",
  available_usage_count: "จำนวนครั้งที่ใช้ได้",
  generic_date: "วันที่",
  sort_by: "Sort by",
  sort_received_newest: "วันที่ได้รับ: ใหม่ → เก่า",
  sort_received_oldest: "วันที่ได้รับ: เก่า → ใหม่",
  sort_expired_latest: "วันหมดอายุ: มาก → น้อย",
  sort_expired_soonest: "วันหมดอายุ: น้อย → มาก",
  register_member_title: "สมัครสมาชิก",
  error: "เกิดข้อผิดพลาด",
  profile_update_error: "เกิดข้อผิดพลาดไม่สามารถแก้ไขข้อมูลได้",
  review_information: "ตรวจสอบข้อมูล",
  email_already_registered: "Email นี้เคยสมัครแล้ว",
  telephone_already_registered: "เบอร์โทรศัพท์นี้มีอยู่ในระบบแล้ว",
  company_information: "ข้อมูลบริษัท",
  news_detail: "รายละเอียดข่าวสาร",
  privilege_detail: "รายละเอียดสิทธิพิเศษ",
  see_all: "ดูทั้งหมด",
  profile_menu_personal_info: "ข้อมูลส่วนตัว",
  profile_menu_spa_credit: "SPA เครดิตของฉัน",
  profile_menu_courses: "คอร์สของฉัน",
  profile_menu_vouchers: "วอเชอร์ของฉัน",
  profile_menu_benefits: "สิทธิประโยชน์ของฉัน",
  profile_menu_service_history: "ประวัติการใช้บริการ",
  profile_menu_purchase_history: "ยอดการซื้อของฉัน",
  profile_menu_reward_history: "ประวัติการแลกรางวัล",
  profile_menu_mission: "มิชชั่นของฉัน",
  profile_menu_friend_invite: "แนะนำเพื่อน",
  redeem_profile_button: "แลกคะแนน",
  used_to: "ใช้ได้ถึง",
  used: "ใช้ไป",
  show_details: "ดูรายละเอียด",
  hide_details: "ซ่อนรายละเอียด",
  filter_last_1_month: "1 เดือนล่าสุด",
  filter_last_3_month: "3 เดือนล่าสุด",
  filter_last_6_month: "6 เดือนล่าสุด"
};
const standardV20 = {
  remark_qr: "แสดงบาร์โค้ดต่อพนักงานเพื่อแสกนทุกครั้งที่ใช้บริการ",
  verify_code_button: "ขอรหัสยืนยัน",
  verify_code_title: "รหัสยืนยัน",
  verify_member_code: "รหัสสมาชิก",
  footer_qr_title: "QR",
  please_fill_data: "กรุณากรอกข้อมูล",
  grand_total: "ยอดสะสม",
  reward_delivery_address_title: "รายละเอียดที่อยู่รับสินค้า",
  reward_delivery_notice:
    "ของรางวัลจะจัดส่งทางไปรษณีย์ กรุณาตรวจสอบ / กรอกข้อมูลให้ครบถ้วน",
  reward_delivery_profile_note:
    "ที่อยู่ในการจัดส่งสินค้า ใช้ที่อยู่เดียวกับที่อยู่ส่วนบุคคล หากมีการแก้ไขจะใช้เป็นข้อมูลล่าสุด",
  reward_home_address: "ที่อยู่",
  reward_province: "จังหวัด",
  reward_district: "เขต",
  reward_subdistrict: "แขวง",
  reward_zip_code: "รหัสไปรษณีย์",
  reward_confirm_redeem_title: "ยืนยันการแลกของรางวัล",

  reward_current_point: "คะแนนสะสมปัจจุบัน",
  reward_required_point: "คะแนนที่ต้องใช้",
  reward_remaining_point: "คะแนนคงเหลือ",
  reward_confirm_with_points: "ยืนยัน ({{points}} คะแนน)",
  reward_success_received_title: "ยินดีด้วยคุณได้รับรางวัล",
  reward_pickup_message:
    "ของรางวัลจะจัดส่งทางไปรษณีย์ กรุณาตรวจสอบ/กรอกข้อมูลให้ครบถ้วน",
  reward_pickup_success_message:
    "ขอบคุณสำหรับการแลกของรางวัล กรุณารอรับสินค้าตามที่อยู่ที่ได้ลงทะเบียนในระบบ",
  reward_back_home: "กลับหน้าหลัก",
  reward_go_to_coupon: "ไปยังหน้าใช้งานคูปอง",
  reward_coupon_used: "คูปองถูกใช้แล้ว",
  reward_insufficient_point: "คะแนนสะสมไม่เพียงพอ",
  reward_cannot_redeem: "ไม่สามารถแลกของขวัญได้",
  reward_redeem_default_button: "กดแลกชุดของขวัญ",
  reward_unregistered_suffix: "(คุณยังไม่ได้ลงทะเบียน)",
  reward_condition_title: "เงื่อนไข",
  reward_condition_fallback: "ไม่เข้าเงื่อนไขการรับของรางวัล",
  footer_spa_title: "SPA",
  all_privilege: "สิทธิประโยชน์ทั้งหมด",
  reward_list: "ของขวัญ",
  section_load_error: "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่อีกครั้ง",
  retry: "ลองใหม่",
  reward_redeem_now_title: "",

  discover: "discover",
  redeem: "แลกคะแนน"
};

const pointToBaht = {
  vv_bottom_navigation_label: "เมนูหลัก Vision Venture",
  vv_retail: "VV Retail",
  point_to_baht_nav_label: "แลกแต้ม",
  point_to_baht_promotion_label: "โปรโมชั่นแลกคะแนน",
  vv_news_read_more: "อ่านเพิ่มเติม",
  point_to_baht_select_amount: "เลือกจำนวนที่ต้องการแลก",
  point_to_baht_discount_received: "ส่วนลดที่ได้",
  point_to_baht_expires_in: "จะหมดอายุ ภายใน",
  point_to_baht_days: "({{days}} วัน)",
  point_to_baht_no_expiry_data: "ยังไม่มีข้อมูลคะแนนที่กำลังหมดอายุ",
  vv_retail_page_title: "เชื่อมต่อแบรนด์ในเครือ VV Retail",
  vv_retail_card_title: "เชื่อมต่อแบรนด์ในเครือ VV Retail",
  vv_retail_click_to_connect: "คลิกเพื่อเชื่อมต่อ",
  profile_menu_marketplace: "เชื่อมต่อ Market Place",
  profile_menu_settings: "ตั้งค่า",
  switch_account: "สลับบัญชี",
  select_profile_title: "กรุณาเลือกโปรไฟล์",
  select_profile_hint:
    "หากต้องการลบโปรไฟล์ กรุณาติดต่อ customer service ผ่านไลน์ Official แอดเลย @bettervisionth",
  create_new_profile: "สร้างโปรไฟล์ใหม่",
  vv_delete_profile_confirm_title: "คำเตือน",
  vv_delete_profile_confirm_message:
    "หากยืนยันการลบโปรไฟล์จะไม่สามารถกู้คืนข้อมูลได้",
  vv_delete_profile_confirm_button: "ยืนยันลบโปรไฟล์",
  vv_register_details_title: "กรุณาระบุข้อมูลให้ถูกต้อง",
  vv_birthday_label: "วัน / เดือน / ปีเกิด",
  vv_birthday_day_title: "วันเกิด",
  vv_birthday_month_title: "เดือนเกิด",
  vv_birthday_year_title_be: "ปีเกิด (พ.ศ.)",
  vv_birthday_year_title_ad: "ปีเกิด (ค.ศ.)",
  vv_birthday_day_placeholder: "วัน",
  vv_birthday_month_placeholder: "เดือน",
  vv_birthday_year_placeholder: "ปี",
  vv_birthday_mismatch_title: "ข้อมูลไม่ถูกต้อง",
  vv_birthday_mismatch_error:
    "วันเกิดไม่ตรงกับข้อมูลสมาชิก กรุณาตรวจสอบอีกครั้ง",
  vv_register_cancel: "ยกเลิก",
  vv_language_confirm: "ยืนยัน",
  vv_language_cancel: "ยกเลิก",
  vv_register_complete_title: "ลงทะเบียนสำเร็จ",
  vv_register_complete_message: "ข้อมูลของคุณได้รับการบันทึกเรียบร้อยแล้ว",
  vv_register_continue: "ดำเนินการต่อ",
  connect_marketplace_title: "ช่องทางการเชื่อมต่อ",
  connect_marketplace_status_connected: "Connected",
  connect_marketplace_shop_name: "ชื่อร้านค้า",
  connect_marketplace_connect_status: "สถานะการเชื่อมต่อ",
  connect_marketplace_select_shop: "เลือกร้านค้า",
  connect_marketplace_success: "เชื่อมต่อสำเร็จ",
  connect: "เชื่อมต่อ",
  point_to_baht_receipt_total: "ยอดรวมใบเสร็จ",
  point_to_baht_discount: "ส่วนลด",
  point_to_baht_receipt_required: "กรุณาระบุยอดรวมใบเสร็จ",
  point_to_baht_points_required: "กรุณาระบุคะแนนที่ต้องการใช้",
  point_to_baht_points_exceed: "คะแนนที่ใช้เกินคะแนนสะสมปัจจุบัน",
  point_to_baht_discount_exceed: "ส่วนลดต้องไม่เกินยอดรวมใบเสร็จ",
  point_to_baht_points_minimum: "แลกคะแนนได้ขั้นต่ำ {{points}} คะแนน",
  point_to_baht_receipt_limit_exceed:
    "สามารถแลกได้สูงสุด {{points}} คะแนน ({{percent}}% ของยอดใบเสร็จ)",
  point_to_baht_coupon_title: "คูปองส่วนลดมูลค่า {{amount}} บาท",
  point_to_baht_coupon_received: "คูปองของคุณพร้อมใช้งานแล้ว",
  point_to_baht_back_to_points: "กลับไปหน้าคะแนนของฉัน"
};

const eyeRecord = {
  eye_record_page_title: "ประวัติค่าสายตา",
  eye_record_lens_type_label: "ประเภทเลนส์",
  eye_record_glasses_tab: "แว่นตา",
  eye_record_contact_lens_tab: "คอนแทคเลนส์",
  eye_record_metric_label: "ประเภทค่าสายตา",
  eye_record_sph_label: "SPH",
  eye_record_cyl_label: "CYL",
  eye_record_add_label: "ADD",
  eye_record_sph_description: "ค่าสายตาสั้น (-) หรือยาว (+)",
  eye_record_cyl_description: "ค่าสายตาเอียงที่เกิดจากความโค้งของกระจกตา",
  eye_record_add_description: "ค่ากำลังของเลนส์สำหรับมองใกล้ (โปรเกรสซีฟ)",
  eye_record_right_eye: "ตาขวา (R)",
  eye_record_left_eye: "ตาซ้าย (L)",
  eye_record_home_title: "ค่าสายตาล่าสุด",
  eye_record_home_history_link: "ดูประวัติค่าสายตา",
  eye_record_home_empty: "คุณยังไม่มีประวัติค่าสายตา",
  eye_record_recommendation_title: "คำแนะนำเพิ่มเติม",
  eye_record_recommendation_one:
    "ค่าสายตาเบื้องต้นไม่สามารถใช้ตัดแว่นได้ทันที ควรปรึกษาผู้เชี่ยวชาญเพื่อประเมินร่วมกับกรอบแว่นจริง",
  eye_record_recommendation_two: "ควรตรวจเช็กค่าสายตาทุก 1 ปี หรือตามนัดหมาย",
  eye_record_recommendation_three:
    "หากค่าสายตามีการเปลี่ยนแปลง ควรตรวจทุก 3-6 เดือน",
  use_until: "ใช้ได้ถึง"
};

const input = {};
const th = {
  ...input,
  ...all,
  ...standardV2,
  ...standardV20,
  ...pointToBaht,
  ...eyeRecord
};
export default th;
